.ux-slider-slide {
  box-sizing: border-box;
  overflow: hidden;
  position: relative !important;

  /** fixes a bug in PL, remove as soon as all
    *   slider across all website' sections use the ux-slider component
    */
  h2 {
    opacity: 1 !important;
  }
}
